
import { Radio } from "ant-design-vue"
const { Group, Button, ...other } = Radio;
const YwRadio = {
	Group: {
		...Group,
		name:"YwRadioGroup"
	},
	Button: {
		...Button,
		name:"YwRadioButton"
	},
	...other,
	name:"YwRadio"
};

YwRadio.install = function (Vue) {
	Vue.component(YwRadio.name, Radio);
	Vue.component(YwRadio.Button.name, Radio.Button);
	Vue.component(YwRadio.Group.name, Radio.Group);
};

export default YwRadio;
